import { Mail, Phone, MapPin, Clock, Send } from "lucide-react";
import { useState } from "react";
import Contact from "../components/Contact";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Спасибо за ваше сообщение! Мы свяжемся с вами в ближайшее время.");
    setFormData({ name: "", email: "", phone: "", service: "", message: "" });
  };

  const contactInfo = [
    {
      icon: Phone,
      title: "Телефон",
       details: "+7 (901) 000-04-06",
      subtext: "Пн-Пт 8:00–18:00",
    },
    {
      icon: Mail,
      title: "Эл. почта",
      details: "info@bart-group.ru",
      subtext: "Отвечаем в течение 24 часов",
    },
    {
      icon: MapPin,
      title: "Адрес офиса",
      details: "ул. Строительная, 123",
      subtext: "Центральный район",
    },
    {
      icon: Clock,
      title: "Часы работы",
      details: "Пн-Пт: 8:00 - 18:00",
      subtext: "Сб: 9:00 - 14:00",
    },
  ];

  return (
    <div className="min-h-screen">
      <section className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Контакты</h1>
          <p className="text-2xl text-gray-300 max-w-2xl">
            Свяжитесь с нашей командой, чтобы обсудить ваш проект
          </p>
        </div>
      </section>
<Contact />
    </div>
  );
}
